// extracted by mini-css-extract-plugin
export default {"zoomModal":"X1-z"};